import { GetCheckoutResponse } from '@wix/ambassador-ecom-v1-checkout/types';

export const hasSubscription = (
  checkoutInfo?: GetCheckoutResponse,
): boolean => {
  return !!checkoutInfo?.checkout?.lineItems?.find(
    (info) => !!info?.subscriptionOptionInfo,
  );
};
